import './utils/resizeObserverErrorFix'; // must be first — suppresses benign ResizeObserver errors before React's overlay registers
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './index.css';

/**
 * Service Worker handling
 *
 * This app uses a custom service worker (`/sw.js`) that caches `/static/js/bundle.js`.
 * That caching is great for PWA/offline, but it can cause "UI not updating" issues,
 * especially when running the dev server (CRACO/CRA) where `bundle.js` is reused.
 *
 * In non-production environments we explicitly UNREGISTER the service worker and
 * clear caches to ensure users always see the latest UI changes.
 */
async function unregisterServiceWorkersAndClearCaches() {
  if (!('serviceWorker' in navigator)) return;

  try {
    const regs = await navigator.serviceWorker.getRegistrations();
    await Promise.all(regs.map((r) => r.unregister()));
  } catch (e) {
    // best-effort
    console.warn('SW unregister failed:', e);
  }

  try {
    if ('caches' in window) {
      const keys = await caches.keys();
      await Promise.all(keys.map((k) => caches.delete(k)));
    }
  } catch (e) {
    // best-effort
    console.warn('Cache clear failed:', e);
  }
}

if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    unregisterServiceWorkersAndClearCaches();
  });
}

// Remember where this visitor came from (utm/ref tags, referrer, landing
// page) so a later sign-up can be attributed to the push that brought them.
try { require('./utils/acquisition').captureFirstTouch(); } catch (_) { /* never block render */ }

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
